import { render, staticRenderFns } from "./clientDetail.vue?vue&type=template&id=ea36e04c&scoped=true"
import script from "./clientDetail.vue?vue&type=script&lang=ts"
export * from "./clientDetail.vue?vue&type=script&lang=ts"
import style0 from "./clientDetail.vue?vue&type=style&index=0&id=ea36e04c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea36e04c",
  null
  
)

export default component.exports